import { SIMILAR_REFLECTION_THRESHOLD } from "./constants";
import type { Reflection } from "./types";

export const getFeelingText = (value: number): string => {
	switch (value) {
		case 3:
			return "Much better than my last daily reflection";
		case 1:
			return "Slightly better than my last daily reflection";
		case -1:
			return "Slightly worse than my last daily reflection";
		case -3:
			return "Much worse than my last daily reflection";
		default:
			return "Select how you're feeling";
	}
};

export const getImpactText = (value: number | null): string | null => {
	switch (value) {
		case 0:
			return "No Impact";
		case 3:
			return "Break-through Positive";
		case 2:
			return "Highly Positive";
		case 1:
			return "Slightly Positive";
		case -1:
			return "Slightly Negative";
		case -2:
			return "Highly Negative";
		case -3:
			return "Critically Negative";
		default:
			return null;
	}
};

export const calculateProgress = (currentStep: string): number => {
	switch (currentStep) {
		case "intro":
			return 0;
		case "checkin":
			return 50;
		case "complete":
			return 100;
		default:
			return 0;
	}
};

export const isSuggestedReflectionSimilar = (
	suggestedTitle: string,
	reflections: Reflection[],
): boolean => {
	if (!suggestedTitle || reflections.length === 0) return false;

	const suggestedWords = suggestedTitle.toLowerCase().split(/\s+/);
	const significantWords = suggestedWords.filter(
		(word) =>
			word.length > 3 &&
			!["with", "and", "the", "for", "from", "about", "that", "this"].includes(
				word,
			),
	);

	return reflections.some((reflection) => {
		const existingWords = reflection.title.toLowerCase().split(/\s+/);
		const matchingWords = significantWords.filter((word) =>
			existingWords.some(
				(existingWord) =>
					existingWord.includes(word) || word.includes(existingWord),
			),
		);

		return (
			matchingWords.length / Math.max(significantWords.length, 1) >
			SIMILAR_REFLECTION_THRESHOLD
		);
	});
};

export const createBookmark = (): void => {
	const title = "Daily Check-in - Reflection Journal";
	const url = window.location.href;
	const isMac =
		typeof navigator !== "undefined" &&
		/Mac|iPod|iPhone|iPad/.test(navigator.platform);
	const shortcut = isMac ? "⌘ + D" : "Ctrl + D";

	try {
		if (
			(window as any).external &&
			typeof (window as any).external.AddFavorite === "function"
		) {
			(window as any).external.AddFavorite(url, title);
			return;
		}

		if (
			(window as any).sidebar &&
			typeof (window as any).sidebar.addPanel === "function"
		) {
			(window as any).sidebar.addPanel(title, url, "");
			return;
		}

		window.alert(
			`To bookmark this page, press ${shortcut} (or use your browser's menu to add a bookmark).`,
		);
	} catch (err) {
		console.error("Bookmark action failed:", err);
		window.alert(
			`To bookmark this page, press ${shortcut} (or use your browser's menu to add a bookmark).`,
		);
	}
};
